const CustomNotificationType = {
    announcement: {
        value: 1,
        label: "Announcement",
    },
    popup: {
        value: 2,
        label: "Popup",
    },
};

export default CustomNotificationType;
